import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IStoreRedux } from 'Types/Reducers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { CampoDeTextoOutlined } from '../styles'
import { get } from '../../../../_axios/requisicao'

interface IProfissao {
  id: number
  nome: string
}

function CampoProfissao() {
  const idProfissao = useSelector<IStoreRedux, number | null>(state => state.dados.idProfissao)
  const profissao = useSelector<IStoreRedux, string | null>(state => state.dados.profissao)
  const dispatch = useDispatch()

  const [opcoes, setOpcoes] = useState<IProfissao[]>([])
  const refPesquisa = useRef(-1)

  const pesquisaProfissoes = useCallback(async (palavraChave: string) => {
    dispatch({ type: 'ALTERA_CARREGANDO', carregando: true })
    const retorno = await get('api-pessoas', `/profissoes?nome=${palavraChave}&limit=100`, {})
    if (retorno.status === 200) {
      setOpcoes(retorno.data)
    }
    dispatch({ type: 'ALTERA_CARREGANDO', carregando: false })
  }, [dispatch])

  const aoSelecionar = useCallback((_, value: IProfissao | null) => {
    if (!value) return

    const { id, nome } = value
    dispatch({ type: 'ALTERA_PROFISSAO', idProfissao: id, profissao: nome })
  }, [dispatch])

  const aoBuscar = useCallback((_, value: string) => {
    window.clearTimeout(refPesquisa.current)
    dispatch({ type: 'ALTERA_PROFISSAO', idProfissao: null, profissao: value })
    refPesquisa.current = window.setTimeout(() => pesquisaProfissoes(value), 800)
  }, [dispatch, pesquisaProfissoes])

  // Carrega profissões ao montar componente
  useEffect(() => {
    if (profissao === null || profissao === '') {
      pesquisaProfissoes('')
    } else {
      pesquisaProfissoes(profissao)
    }
  }, [])

  // Validação (profissão é opcional, sempre válida)
  useEffect(() => {
    const regex = /^\d{1,}$/
    const resultado = idProfissao === null ? true : regex.test(String(idProfissao))
    dispatch({ type: 'VALIDA_CAMPO', profissao: resultado })
  }, [dispatch, idProfissao])

  return (
    <div className="campo-formulario">
      <Autocomplete
        freeSolo
        clearOnEscape
        disableClearable
        fullWidth
        getOptionLabel={option => option.nome}
        options={opcoes}
        onChange={aoSelecionar}
        onInputChange={aoBuscar}
        renderInput={(params) =>
          <CampoDeTextoOutlined
            {...params}
            InputProps={{ ref: params.InputProps.ref }}
            fullWidth
            label='Profissão (opcional)'
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
              value: profissao || ''
            }}
          />
        }
      />
    </div>
  )
}

export default CampoProfissao
